import SvgDot from '@sats-group/icons/16/dot';
import Link from '@sats-group/ui-lib/react/link';
import Tag from '@sats-group/ui-lib/react/tag';
import Text from '@sats-group/ui-lib/react/text';
import clsx from 'clsx';
import React, { useState } from 'react';
import { RemoveMember } from '~/source/ui/remove-member/remove-member';
import type { Members as Props } from './members.page.types';

type OutcomeHandler = NonNullable<
  Parameters<typeof RemoveMember>[0]['onOutcome']
>;
type Outcome = Parameters<OutcomeHandler>[0];

export const MembersEntry: React.FC<Props['list']['items'][number]> = entry => {
  const [outcome, setOutcome] = useState<Outcome>();
  const handleOutcome: OutcomeHandler = _outcome => setOutcome(_outcome);

  return (
    <tr
      className={clsx('members-entry', {
        'members-entry--failure': outcome === 'FAILURE',
        'members-entry--removed': outcome === 'SUCCESS',
      })}
    >
      <td className="members-entry__name">
        {outcome === 'SUCCESS' ? (
          <Text>{entry.name}</Text>
        ) : (
          <Link href={entry.href} text={entry.name} />
        )}
      </td>
      <td className="members-entry__status">
        <Tag {...entry.status} icon={<SvgDot />} size={Tag.sizes.s} />
      </td>
      <td>
        {entry.memberUntil ? (
          <React.Fragment>
            <span className="members-entry__slim-only">
              <Text elementName="span">{entry.memberUntil.label}</Text>
            </span>
            <Text elementName="span">{entry.memberUntil.value}</Text>
          </React.Fragment>
        ) : null}
      </td>
      <td className="members-entry__action">
        <RemoveMember
          {...entry.actions.remove}
          onOutcome={handleOutcome}
          small
        />
      </td>
    </tr>
  );
};
